import { render } from "./EditAdminPage.vue?vue&type=template&id=7dbde619&scoped=true"
import script from "./EditAdminPage.vue?vue&type=script&lang=js"
export * from "./EditAdminPage.vue?vue&type=script&lang=js"

import "./EditAdminPage.vue?vue&type=style&index=0&id=7dbde619&scoped=true&lang=css"

import exportComponent from "/home/runner/work/Verent_PactoAdmin_FE_UI/Verent_PactoAdmin_FE_UI/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7dbde619"]])

export default __exports__